
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("jupik", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");


var $6f0Oj = parcelRequire("6f0Oj");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $cO1el = parcelRequire("cO1el");


var $hmuev = parcelRequire("hmuev");


var $gj7hi = parcelRequire("gj7hi");


var $6xdDU = parcelRequire("6xdDU");


var $eEA8O = parcelRequire("eEA8O");


var $inPa6 = parcelRequire("inPa6");


var $8DN9t = parcelRequire("8DN9t");


var $cyLm6 = parcelRequire("cyLm6");


var $isYda = parcelRequire("isYda");


var $9Q2dU = parcelRequire("9Q2dU");


var $ZDq1z = parcelRequire("ZDq1z");


var $fXbFR = parcelRequire("fXbFR");


var $f7Bnv = parcelRequire("f7Bnv");


var $dqdrq = parcelRequire("dqdrq");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $9oxdN = parcelRequire("9oxdN");











var $eSUdr = parcelRequire("eSUdr");










var $xQxzY = parcelRequire("xQxzY");




var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");


















var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");





var $lOHzS = parcelRequire("lOHzS");


var $3Mg7y = parcelRequire("3Mg7y");


var $fxBfz = parcelRequire("fxBfz");








var $ctmPb = parcelRequire("ctmPb");


var $4ymSL = parcelRequire("4ymSL");


var $4NZXC = parcelRequire("4NZXC");














var $1ytiN = parcelRequire("1ytiN");


var $7Sm4c = parcelRequire("7Sm4c");





var $7CeAz = parcelRequire("7CeAz");


var $cLo2u = parcelRequire("cLo2u");


var $17wUi = parcelRequire("17wUi");


var $9wGTI = parcelRequire("9wGTI");


var $lsxnT = parcelRequire("lsxnT");


var $jhwJP = parcelRequire("jhwJP");


var $3Bn5C = parcelRequire("3Bn5C");























var $8lYIw = parcelRequire("8lYIw");

const $01ec9082b70ec97f$var$iconBoxStyle = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.information',
    height: '40px',
    width: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 'radius.small'
});
const $01ec9082b70ec97f$var$imgStyle = (0, $ecnYn.xcss)({
    width: '40px',
    paddingTop: 'space.050'
});
const $01ec9082b70ec97f$var$titleTextStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 653)"
});
const $01ec9082b70ec97f$var$bodyTextStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $01ec9082b70ec97f$var$linkTextStyle = (0, $ecnYn.xcss)({
    color: 'color.link',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $01ec9082b70ec97f$export$a7b06bfba60a8a78 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(20);
    const { label: label, icon: icon, title: title, bodyText: bodyText, linkText: linkText, link: link, onLinkClick: onLinkClick } = t0;
    const Icon = icon;
    const t1 = label || "";
    let t2;
    if ($[0] !== Icon || $[1] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $01ec9082b70ec97f$var$imgStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $01ec9082b70ec97f$var$iconBoxStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: t1,
            color: "var(--ds-icon-information, #357DE8)"
        })));
        $[0] = Icon;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== title) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $01ec9082b70ec97f$var$titleTextStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), title));
        $[3] = title;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== bodyText) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $01ec9082b70ec97f$var$bodyTextStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), bodyText));
        $[5] = bodyText;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== linkText) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), linkText);
        $[7] = linkText;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== link || $[10] !== onLinkClick || $[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $01ec9082b70ec97f$var$linkTextStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8lYIw.Link), {
            target: "_blank",
            href: link,
            onClick: onLinkClick
        }, t5));
        $[9] = link;
        $[10] = onLinkClick;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== t3 || $[14] !== t4 || $[15] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            space: "space.050"
        }, t3, t4, t6);
        $[13] = t3;
        $[14] = t4;
        $[15] = t6;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== t2 || $[18] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            space: "space.200"
        }, t2, t7);
        $[17] = t2;
        $[18] = t7;
        $[19] = t8;
    } else t8 = $[19];
    return t8;
} : ({ label: label, icon: icon, title: title, bodyText: bodyText, linkText: linkText, link: link, onLinkClick: onLinkClick })=>{
    const Icon = icon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $01ec9082b70ec97f$var$imgStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $01ec9082b70ec97f$var$iconBoxStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: label || '',
        color: "var(--ds-icon-information, #357DE8)"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $01ec9082b70ec97f$var$titleTextStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $01ec9082b70ec97f$var$bodyTextStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), bodyText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $01ec9082b70ec97f$var$linkTextStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8lYIw.Link), {
        target: "_blank",
        href: link,
        onClick: onLinkClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), linkText)))));
};



var $1NBp8 = parcelRequire("1NBp8");

const $168e181c3998994c$export$5b8f1e0a69cf5e54 = {
    AI: 'https://www.atlassian.com/platform/artificial-intelligence',
    TeamCalendars: 'https://www.atlassian.com/software/confluence/team-calendars',
    Whiteboard: 'https://www.atlassian.com/software/confluence/whiteboards',
    Automation: 'https://www.atlassian.com/software/confluence/automation',
    Analytics: 'https://support.atlassian.com/confluence-cloud/docs/view-insights-on-spaces/',
    CompanyHub: 'https://www.atlassian.com/software/confluence/use-cases/intranet-software',
    ContentManager: 'https://support.atlassian.com/confluence-cloud/docs/manage-your-content-tree/',
    SpacePermission: 'https://support.atlassian.com/confluence-cloud/docs/what-are-space-permissions/'
};
class $168e181c3998994c$export$d213136284bb1cdf {
    getAi() {
        return $168e181c3998994c$export$5b8f1e0a69cf5e54.AI;
    }
    getTeamCalendars() {
        const spaceKeys = [
            this.currentSpaceKey,
            this.starredSpaceKey,
            this.recentSpaceKey
        ];
        const spaceKey = spaceKeys.find((spaceKey)=>spaceKey !== null && spaceKey !== undefined);
        if (!spaceKey) return $168e181c3998994c$export$5b8f1e0a69cf5e54.TeamCalendars;
        return (0, $1NBp8.SPACE_CALENDARS).toUrl({
            spaceKey: spaceKey
        });
    }
    getWhiteboard({ source: source } = {}) {
        if (!this.personalSpaceKey || !source) return $168e181c3998994c$export$5b8f1e0a69cf5e54.Whiteboard;
        return (0, $1NBp8.CREATE_CONTENT).toUrl({
            contentType: 'whiteboard'
        }, {
            query: {
                spaceKey: this.personalSpaceKey,
                source: source
            }
        });
    }
    getAutomationEndUser() {
        if (!this.personalSpaceKey) return $168e181c3998994c$export$5b8f1e0a69cf5e54.Automation;
        return (0, $1NBp8.SPACE_SETTINGS_AUTOMATION).toUrl({
            spaceKey: this.personalSpaceKey
        }, {
            hash: '#/tab/rule-library'
        });
    }
    getAutomationAdmin() {
        return (0, $1NBp8.ADMIN_GLOBAL_AUTOMATION).toUrl({}, {
            hash: '#/tab/rule-library'
        });
    }
    getAnalytics() {
        if (!this.popularSpaceKey) return $168e181c3998994c$export$5b8f1e0a69cf5e54.Analytics;
        return (0, $1NBp8.SPACE_ANALYTICS).toUrl({
            spaceKey: this.popularSpaceKey
        });
    }
    getCompanyHub({ isCompanyHubEnabled: isCompanyHubEnabled } = {}) {
        if (!isCompanyHubEnabled) return $168e181c3998994c$export$5b8f1e0a69cf5e54.CompanyHub;
        /* /wiki/company-hub route shows not found screen if CH hasn't been created, so we are using the create CH aritcle link for now
     Details: https://atlassian.slack.com/archives/C05G147TUQ1/p1725038871932349 */ return 'https://support.atlassian.com/confluence-cloud/docs/create-and-customize-a-company-hub/';
    }
    getMissionControl() {
        return (0, $1NBp8.ADMIN_CENTER).toUrl();
    }
    getContentManager() {
        if (!this.popularSpaceKey) return $168e181c3998994c$export$5b8f1e0a69cf5e54.ContentManager;
        return (0, $1NBp8.SPACE_BULK_TOOLS).toUrl({
            spaceKey: this.popularSpaceKey
        });
    }
    getSpacePermission() {
        if (!this.personalSpaceKey) return $168e181c3998994c$export$5b8f1e0a69cf5e54.SpacePermission;
        return (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).toUrl({
            spaceKey: this.personalSpaceKey,
            tab: 'users'
        });
    }
    constructor({ recentSpaceKey: recentSpaceKey, starredSpaceKey: starredSpaceKey, currentSpaceKey: currentSpaceKey, personalSpaceKey: personalSpaceKey, popularSpaceKey: popularSpaceKey } = {}){
        this.recentSpaceKey = void 0;
        this.starredSpaceKey = void 0;
        this.currentSpaceKey = void 0;
        this.personalSpaceKey = void 0;
        this.popularSpaceKey = void 0;
        this.recentSpaceKey = recentSpaceKey;
        this.starredSpaceKey = starredSpaceKey;
        this.currentSpaceKey = currentSpaceKey;
        this.personalSpaceKey = personalSpaceKey;
        this.popularSpaceKey = popularSpaceKey;
    }
}












var $gdv5Z = parcelRequire("gdv5Z");




var $1cfRh = parcelRequire("1cfRh");


var $8TTLA = parcelRequire("8TTLA");

var $8CZUH = parcelRequire("8CZUH");

const $dd6c5da567a6ff5f$var$headerStyles = {
    header: "_1e0c1txw _4cvr1h6o _1bah1yb4 _2lx21sbv _kqswstnw _154iidpf _1xi2ukr8 _1ltvidpf _1pbykb7n",
    container: "_kqswh2mm _4t3i1osq"
};
const $dd6c5da567a6ff5f$var$i18n = (0, $h82at.defineMessages)({
    closeModal: {
        id: "premium-trial.learn-more.video.close-modal.label",
        defaultMessage: "Close video modal"
    }
});
const $dd6c5da567a6ff5f$export$41318e6dd18eedd1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { onClose: onClose } = t0;
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage($dd6c5da567a6ff5f$var$i18n.closeModal);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== onClose || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $dd6c5da567a6ff5f$var$headerStyles.header
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
            onClick: onClose,
            label: t1,
            testId: "learn-more-video-modal-close-button"
        }));
        $[2] = onClose;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("iframe", {
            width: "100%",
            height: "100%",
            src: "https://www.youtube.com/embed/UYYe0Qbs9fs?si=PtVPpFx_Jiued9de",
            frameBorder: "0",
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen",
            title: "Explore Confluence Premium"
        });
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t2) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $dd6c5da567a6ff5f$var$headerStyles.container
        }, t2, t3);
        $[6] = t2;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== onClose || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
            onClose: onClose,
            width: "large",
            height: "474px"
        }, t4);
        $[8] = onClose;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
} : ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
        onClose: onClose,
        width: "large",
        height: "474px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $dd6c5da567a6ff5f$var$headerStyles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $dd6c5da567a6ff5f$var$headerStyles.header
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
        onClick: onClose,
        label: formatMessage($dd6c5da567a6ff5f$var$i18n.closeModal),
        testId: "learn-more-video-modal-close-button"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("iframe", {
        width: "100%",
        height: "100%",
        src: "https://www.youtube.com/embed/UYYe0Qbs9fs?si=PtVPpFx_Jiued9de",
        frameBorder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen",
        title: "Explore Confluence Premium"
    })));
};


const $c48461bf82b3a37e$var$i18nBase = (0, $h82at.defineMessages)({
    modalTitle: {
        id: "premium-trial.onboarding.mt.modal.title",
        defaultMessage: "Welcome to your Premium trial"
    },
    modalDescription: {
        id: "premium-trial.onboarding.mt.modal.description",
        defaultMessage: "Get started by exploring our 5 most popular features."
    },
    videoButtonText: {
        id: "premium-trial.onboarding.mt.video-button.text",
        defaultMessage: "Watch a summary of Premium"
    },
    /* features */ aiTitle: {
        id: "premium-trial.onboarding.mt.ai.title",
        defaultMessage: "Atlassian Intelligence (AI)"
    },
    aiDesciption: {
        id: "premium-trial.onboarding.mt.ai.description",
        defaultMessage: "Work smarter by leveraging AI-powered editing experiences to create and summarize content."
    },
    aiAction: {
        id: "premium-trial.onboarding.mt.ai.action",
        defaultMessage: "Discover the power of AI"
    },
    companyHubTitle: {
        id: "premium-trial.onboarding.mt.company-hub.title",
        defaultMessage: "Company Hub"
    },
    companyHubDescription: {
        id: "premium-trial.onboarding.mt.company-hub.description",
        defaultMessage: "Help your teams stay connected with a centralized intranet for key announcements and resources."
    },
    companyHubAction: {
        id: "premium-trial.onboarding.mt.company-hub.action",
        defaultMessage: "Customize my company hub"
    },
    automationTitle: {
        id: "premium-trial.onboarding.mt.automation.title",
        defaultMessage: "Automation"
    },
    automationDescription: {
        id: "premium-trial.onboarding.mt.automation.description",
        defaultMessage: "Save time by creating rules to change content status, create a Jira task, and more."
    },
    automationAction: {
        id: "premium-trial.onboarding.mt.automation.action",
        defaultMessage: "Build an automation rule"
    },
    missionControlTitle: {
        id: "premium-trial.onboarding.mt.mission-control.title",
        defaultMessage: "Mission control"
    },
    missionControlDescription: {
        id: "premium-trial.onboarding.mt.mission-control.description",
        defaultMessage: "Boost your team\u2019s productivity with insights and controls for data-driven improvements."
    },
    missionControlAction: {
        id: "premium-trial.onboarding.mt.mission-control.action",
        defaultMessage: "Go to mission control"
    },
    contentManagerTitle: {
        id: "premium-trial.onboarding.mt.content-manager.title",
        defaultMessage: "Content manager"
    },
    contentManagerDescription: {
        id: "premium-trial.onboarding.mt.content-manager.description",
        defaultMessage: "Keep content organized and make bulk changes across hundreds of pages simultaneously."
    },
    contentManagerAction: {
        id: "premium-trial.onboarding.mt.content-manager.action",
        defaultMessage: "View my content manager"
    },
    teamCalendarsTitle: {
        id: "premium-trial.onboarding.mt.team-calendars.title",
        defaultMessage: "Team calendars"
    },
    teamCalendarsDescription: {
        id: "premium-trial.onboarding.mt.team-calendars.description",
        defaultMessage: "Keep one single source of truth for your team\u2019s schedules and due dates."
    },
    teamCalendarsAction: {
        id: "premium-trial.onboarding.mt.team-calendars.action",
        defaultMessage: "Go to team calendars"
    },
    unlimitedWhiteBoardsTitle: {
        id: "premium-trial.onboarding.mt.unlimited-whiteboards.title",
        defaultMessage: "Whiteboards and Jira without limits"
    },
    unlimitedWhiteBoardsDescription: {
        id: "premium-trial.onboarding.mt.unlimited-whiteboards.description",
        defaultMessage: "Brainstorm without boundaries and turn ideas into Jira tasks from one single location."
    },
    unlimitedWhiteBoardsAction: {
        id: "premium-trial.onboarding.mt.unlimited-whiteboards.action",
        defaultMessage: "Create a whiteboard"
    },
    analyticsTitle: {
        id: "premium-trial.onboarding.mt.analytics.title",
        defaultMessage: "Analytics"
    },
    analyticsDescription: {
        id: "premium-trial.onboarding.mt.analytics.description",
        defaultMessage: "See user engagement and views at the site, space, and content level."
    },
    analyticsAction: {
        id: "premium-trial.onboarding.mt.analytics.action",
        defaultMessage: "View analytics"
    }
});
const $c48461bf82b3a37e$var$i18nLiveDocs = (0, $h82at.defineMessages)({
    contentManagerDescription: {
        id: "premium-trial.onboarding.mt.content-manager.description.livedocs",
        defaultMessage: "Keep content organized and make bulk changes across hundreds of pages and live docs simultaneously."
    }
});
const $c48461bf82b3a37e$var$i18n = (0, $jhwJP.mergeLiveDocI18n)($c48461bf82b3a37e$var$i18nBase, $c48461bf82b3a37e$var$i18nLiveDocs);
const $c48461bf82b3a37e$var$imageContainerStyles = (0, $ecnYn.xcss)({
    width: '145',
    minInlineSize: 'max-content'
});
const $c48461bf82b3a37e$var$imageStyles = null;
var $c48461bf82b3a37e$export$9d84cfc6d3c9c31c = /*#__PURE__*/ function(MODAL_TRIGGER) {
    MODAL_TRIGGER["ONBOARDING"] = "onboarding";
    return MODAL_TRIGGER;
}({});
var $c48461bf82b3a37e$var$Features = /*#__PURE__*/ function(Features) {
    Features["AI"] = "atlassianIntelligence";
    Features["TEAM_CALENDARS"] = "teamCalendars";
    Features["COMPANY_HUB"] = "companyHub";
    Features["UNLIMITED_WHITEBOARDS"] = "unlimitedWhiteboards";
    Features["AUTOMATION"] = "automation";
    Features["MISSION_CONTROL"] = "missionControl";
    Features["CONTENT_MANAGER"] = "contentManager";
    Features["ANALYTICS"] = "analytics";
    return Features;
}($c48461bf82b3a37e$var$Features || {});
const $c48461bf82b3a37e$var$featuresMapper = [
    {
        key: "atlassianIntelligence",
        title: $c48461bf82b3a37e$var$i18n.aiTitle,
        bodyText: $c48461bf82b3a37e$var$i18n.aiDesciption,
        linkText: $c48461bf82b3a37e$var$i18n.aiAction,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))),
        showToAdmin: true,
        showToEndUser: true
    },
    {
        key: "teamCalendars",
        title: $c48461bf82b3a37e$var$i18n.teamCalendarsTitle,
        bodyText: $c48461bf82b3a37e$var$i18n.teamCalendarsDescription,
        linkText: $c48461bf82b3a37e$var$i18n.teamCalendarsAction,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))),
        showToAdmin: false,
        showToEndUser: true
    },
    {
        key: "companyHub",
        title: $c48461bf82b3a37e$var$i18n.companyHubTitle,
        bodyText: $c48461bf82b3a37e$var$i18n.companyHubDescription,
        linkText: $c48461bf82b3a37e$var$i18n.companyHubAction,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ctmPb))),
        showToAdmin: true,
        showToEndUser: false
    },
    {
        key: "unlimitedWhiteboards",
        title: $c48461bf82b3a37e$var$i18n.unlimitedWhiteBoardsTitle,
        bodyText: $c48461bf82b3a37e$var$i18n.unlimitedWhiteBoardsDescription,
        linkText: $c48461bf82b3a37e$var$i18n.unlimitedWhiteBoardsAction,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        showToAdmin: false,
        showToEndUser: true
    },
    {
        key: "automation",
        title: $c48461bf82b3a37e$var$i18n.automationTitle,
        bodyText: $c48461bf82b3a37e$var$i18n.automationDescription,
        linkText: $c48461bf82b3a37e$var$i18n.automationAction,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fxBfz))),
        showToAdmin: true,
        showToEndUser: true
    },
    {
        key: "missionControl",
        title: $c48461bf82b3a37e$var$i18n.missionControlTitle,
        bodyText: $c48461bf82b3a37e$var$i18n.missionControlDescription,
        linkText: $c48461bf82b3a37e$var$i18n.missionControlAction,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4ymSL))),
        showToAdmin: true,
        showToEndUser: false
    },
    {
        key: "contentManager",
        title: $c48461bf82b3a37e$var$i18n.contentManagerTitle,
        bodyText: $c48461bf82b3a37e$var$i18n.contentManagerDescription,
        linkText: $c48461bf82b3a37e$var$i18n.contentManagerAction,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4NZXC))),
        showToAdmin: true,
        showToEndUser: false
    },
    {
        key: "analytics",
        title: $c48461bf82b3a37e$var$i18n.analyticsTitle,
        bodyText: $c48461bf82b3a37e$var$i18n.analyticsDescription,
        linkText: $c48461bf82b3a37e$var$i18n.analyticsAction,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cyLm6))),
        showToAdmin: false,
        showToEndUser: true
    }
];
const $c48461bf82b3a37e$export$5478df32444b3540 = 'premiumOnboardingManualTrialModal';
const $c48461bf82b3a37e$var$modalClosedLocalStorageKey = 'premium.trial.onboarding.mt.modal.closed';
const $c48461bf82b3a37e$export$ee19e0d1f60d67c2 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(76);
    const { onClose: onClose, stop: stop, onCloseComplete: onCloseComplete, modalTrigger: t1 } = t0;
    const modalTrigger = t1 === undefined ? "onboarding" : t1;
    const [isOpen, setIsOpen] = (0, $42omo.useState)(true);
    const [isLearnMoreVideoOpen, setIsLearnMoreVideoIsOpen] = (0, $42omo.useState)(false);
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { isCompanyHubEntryPointEnabled: isCompanyHubEntryPointEnabled } = (0, $7CeAz.useIsCompanyHubEnabled)();
    const currentSpaceKey = (0, $cLo2u.useSpaceKey)();
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $eSUdr.default)`query OnboardingManualTrialModalQuery{personalSpace:confluence_atlassianUser(current:true){id confluence{hasPersonalSpace space{id alias}}}popularSpaces:popularFeed(first:25){nodes{content{id space{id alias type}}}}starredSpace:spaces(favourite:true first:1 status:"current"){nodes{id alias}}recentSpaces:recentlyViewedSpaces{id alias}}`;
        $[0] = t2;
    } else t2 = $[0];
    const { data: t3, error: error } = (0, $xQxzY.useQuery)(t2);
    let t4;
    if ($[1] !== t3) {
        t4 = t3 === undefined ? {} : t3;
        $[1] = t3;
        $[2] = t4;
    } else t4 = $[2];
    const { personalSpace: personalSpace, popularSpaces: popularSpaces, starredSpace: starredSpace, recentSpaces: recentSpaces } = t4;
    const personalSpaceKey = personalSpace?.confluence?.hasPersonalSpace && personalSpace?.confluence?.space?.alias || undefined;
    let t5;
    if ($[3] !== popularSpaces?.nodes) {
        t5 = popularSpaces?.nodes.find($c48461bf82b3a37e$var$_temp);
        $[3] = popularSpaces?.nodes;
        $[4] = t5;
    } else t5 = $[4];
    const popularSpace = t5;
    const popularSpaceKey = popularSpace?.content?.space?.alias || undefined;
    const starredSpaceKey = starredSpace?.nodes?.[0]?.alias || undefined;
    const recentSpaceKey = recentSpaces?.[0]?.alias || undefined;
    if (error && !(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    const t6 = currentSpaceKey || undefined;
    let t7;
    if ($[5] !== personalSpaceKey || $[6] !== popularSpaceKey || $[7] !== recentSpaceKey || $[8] !== starredSpaceKey || $[9] !== t6) {
        t7 = new (0, $168e181c3998994c$export$d213136284bb1cdf)({
            personalSpaceKey: personalSpaceKey,
            popularSpaceKey: popularSpaceKey,
            starredSpaceKey: starredSpaceKey,
            recentSpaceKey: recentSpaceKey,
            currentSpaceKey: t6
        });
        $[5] = personalSpaceKey;
        $[6] = popularSpaceKey;
        $[7] = recentSpaceKey;
        $[8] = starredSpaceKey;
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    const premiumFeatureDeeplinks = t7;
    let t8;
    if ($[11] !== premiumFeatureDeeplinks) {
        t8 = premiumFeatureDeeplinks.getAi();
        $[11] = premiumFeatureDeeplinks;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] !== premiumFeatureDeeplinks) {
        t9 = premiumFeatureDeeplinks.getTeamCalendars();
        $[13] = premiumFeatureDeeplinks;
        $[14] = t9;
    } else t9 = $[14];
    let t10;
    if ($[15] !== isCompanyHubEntryPointEnabled || $[16] !== premiumFeatureDeeplinks) {
        t10 = premiumFeatureDeeplinks.getCompanyHub({
            isCompanyHubEnabled: isCompanyHubEntryPointEnabled
        });
        $[15] = isCompanyHubEntryPointEnabled;
        $[16] = premiumFeatureDeeplinks;
        $[17] = t10;
    } else t10 = $[17];
    let t11;
    if ($[18] !== premiumFeatureDeeplinks) {
        t11 = premiumFeatureDeeplinks.getWhiteboard({
            source: $c48461bf82b3a37e$export$5478df32444b3540
        });
        $[18] = premiumFeatureDeeplinks;
        $[19] = t11;
    } else t11 = $[19];
    let t12;
    if ($[20] !== isSiteAdmin || $[21] !== premiumFeatureDeeplinks) {
        t12 = isSiteAdmin ? premiumFeatureDeeplinks.getAutomationAdmin() : premiumFeatureDeeplinks.getAutomationEndUser();
        $[20] = isSiteAdmin;
        $[21] = premiumFeatureDeeplinks;
        $[22] = t12;
    } else t12 = $[22];
    let t13;
    if ($[23] !== premiumFeatureDeeplinks) {
        t13 = premiumFeatureDeeplinks.getMissionControl();
        $[23] = premiumFeatureDeeplinks;
        $[24] = t13;
    } else t13 = $[24];
    let t14;
    if ($[25] !== premiumFeatureDeeplinks) {
        t14 = premiumFeatureDeeplinks.getContentManager();
        $[25] = premiumFeatureDeeplinks;
        $[26] = t14;
    } else t14 = $[26];
    let t15;
    if ($[27] !== premiumFeatureDeeplinks) {
        t15 = premiumFeatureDeeplinks.getAnalytics();
        $[27] = premiumFeatureDeeplinks;
        $[28] = t15;
    } else t15 = $[28];
    let t16;
    if ($[29] !== t10 || $[30] !== t11 || $[31] !== t12 || $[32] !== t13 || $[33] !== t14 || $[34] !== t15 || $[35] !== t8 || $[36] !== t9) {
        t16 = {
            ["atlassianIntelligence"]: t8,
            ["teamCalendars"]: t9,
            ["companyHub"]: t10,
            ["unlimitedWhiteboards"]: t11,
            ["automation"]: t12,
            ["missionControl"]: t13,
            ["contentManager"]: t14,
            ["analytics"]: t15
        };
        $[29] = t10;
        $[30] = t11;
        $[31] = t12;
        $[32] = t13;
        $[33] = t14;
        $[34] = t15;
        $[35] = t8;
        $[36] = t9;
        $[37] = t16;
    } else t16 = $[37];
    const featureLinksMapper = t16;
    let t17;
    if ($[38] !== isSiteAdmin) {
        t17 = (feature)=>isSiteAdmin && feature.showToAdmin || !isSiteAdmin && feature.showToEndUser;
        $[38] = isSiteAdmin;
        $[39] = t17;
    } else t17 = $[39];
    const featuresToShow = $c48461bf82b3a37e$var$featuresMapper.filter(t17);
    if ((0, $9wGTI.fg)("a4c_free_and_standard_editions")) {
        const automationIdx = featuresToShow.findIndex($c48461bf82b3a37e$var$_temp2);
        featuresToShow.splice(automationIdx, 1);
    }
    const modalRef = (0, $42omo.useRef)(null);
    const { getDwellTime: getDwellTime } = (0, $fXbFR.usePopupDwellTime)(modalRef);
    const hasLinkEventFiredWithDwellTime = (0, $42omo.useRef)(false);
    let t18;
    if ($[40] !== createAnalyticsEvent || $[41] !== getDwellTime || $[42] !== modalTrigger || $[43] !== onClose) {
        t18 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "ptoManualTrialModalCloseButton",
                    source: $c48461bf82b3a37e$export$5478df32444b3540,
                    attributes: {
                        dwellTime: getDwellTime(),
                        modalTrigger: modalTrigger
                    }
                }
            }).fire();
            setIsOpen(false);
            onClose?.();
        };
        $[40] = createAnalyticsEvent;
        $[41] = getDwellTime;
        $[42] = modalTrigger;
        $[43] = onClose;
        $[44] = t18;
    } else t18 = $[44];
    const closeModal = t18;
    let t19;
    if ($[45] !== createAnalyticsEvent || $[46] !== getDwellTime || $[47] !== modalTrigger) {
        t19 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "premiumVideoModalButton",
                    source: $c48461bf82b3a37e$export$5478df32444b3540,
                    attributes: {
                        dwellTime: getDwellTime(),
                        modalTrigger: modalTrigger
                    }
                }
            }).fire();
            setIsLearnMoreVideoIsOpen(true);
        };
        $[45] = createAnalyticsEvent;
        $[46] = getDwellTime;
        $[47] = modalTrigger;
        $[48] = t19;
    } else t19 = $[48];
    const openLearnMoreVideo = t19;
    let t20;
    if ($[49] !== createAnalyticsEvent || $[50] !== modalTrigger) {
        t20 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "premiumVideoModalCloseButton",
                    source: $c48461bf82b3a37e$export$5478df32444b3540,
                    attributes: {
                        modalTrigger: modalTrigger
                    }
                }
            }).fire();
            setIsLearnMoreVideoIsOpen(false);
        };
        $[49] = createAnalyticsEvent;
        $[50] = modalTrigger;
        $[51] = t20;
    } else t20 = $[51];
    const closeLearnMoreVideo = t20;
    let t21;
    let t22;
    if ($[52] !== createAnalyticsEvent || $[53] !== isSiteAdmin || $[54] !== modalTrigger) {
        t21 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: $c48461bf82b3a37e$export$5478df32444b3540,
                    attributes: {
                        isSiteAdmin: isSiteAdmin,
                        modalTrigger: modalTrigger
                    }
                }
            }).fire();
        };
        t22 = [
            createAnalyticsEvent,
            isSiteAdmin,
            modalTrigger
        ];
        $[52] = createAnalyticsEvent;
        $[53] = isSiteAdmin;
        $[54] = modalTrigger;
        $[55] = t21;
        $[56] = t22;
    } else {
        t21 = $[55];
        t22 = $[56];
    }
    (0, $42omo.useEffect)(t21, t22);
    let t23;
    if ($[57] !== createAnalyticsEvent || $[58] !== getDwellTime || $[59] !== isSiteAdmin || $[60] !== modalTrigger || $[61] !== stop) {
        t23 = (feature_1)=>{
            let dwellTime = {};
            if (!hasLinkEventFiredWithDwellTime.current) {
                dwellTime = {
                    dwellTime: getDwellTime()
                };
                hasLinkEventFiredWithDwellTime.current = true;
            }
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "link",
                    actionSubjectId: "premiumFeatureDeeplink",
                    source: $c48461bf82b3a37e$export$5478df32444b3540,
                    attributes: {
                        feature: feature_1,
                        isSiteAdmin: isSiteAdmin,
                        ...dwellTime,
                        modalTrigger: modalTrigger
                    }
                }
            }).fire();
            stop?.();
            modalTrigger === "onboarding" && (0, $17wUi.confluenceLocalStorageInstance).setItem($c48461bf82b3a37e$var$modalClosedLocalStorageKey, "true");
        };
        $[57] = createAnalyticsEvent;
        $[58] = getDwellTime;
        $[59] = isSiteAdmin;
        $[60] = modalTrigger;
        $[61] = stop;
        $[62] = t23;
    } else t23 = $[62];
    const onLinkClick = t23;
    if (modalTrigger === "onboarding" && (0, $17wUi.confluenceLocalStorageInstance).getItem($c48461bf82b3a37e$var$modalClosedLocalStorageKey)) return null;
    const T0 = (0, $hSqtY.TransparentErrorBoundary);
    const t24 = (0, $3IBnw.Attribution);
    let t25;
    if ($[63] !== closeLearnMoreVideo || $[64] !== isLearnMoreVideoOpen) {
        t25 = isLearnMoreVideoOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dd6c5da567a6ff5f$export$41318e6dd18eedd1), {
            onClose: closeLearnMoreVideo
        });
        $[63] = closeLearnMoreVideo;
        $[64] = isLearnMoreVideoOpen;
        $[65] = t25;
    } else t25 = $[65];
    let t26;
    if ($[66] !== t25) {
        t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, t25);
        $[66] = t25;
        $[67] = t26;
    } else t26 = $[67];
    const T1 = (0, $6xdDU.default);
    const t27 = isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        autoFocus: false,
        width: 752,
        shouldScrollInViewport: true,
        onCloseComplete: onCloseComplete
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        ref: modalRef,
        alignBlock: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $c48461bf82b3a37e$var$imageContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3Bn5C))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($3Bn5C))),
        alt: "Premium trial onboarding modal",
        className: (0, $gMc0m.default)([
            "_5ral1dfr _1tke1osq _1bsb93m8 _4t3i1kdj"
        ])
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        padding: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        onClick: closeModal,
        label: "Close Modal"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        paddingInline: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "medium",
        as: "h1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c48461bf82b3a37e$var$i18n.modalTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c48461bf82b3a37e$var$i18n.modalDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.300"
    }, featuresToShow.map((feature_2)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $01ec9082b70ec97f$export$a7b06bfba60a8a78), {
            label: feature_2.key,
            bodyText: feature_2.bodyText,
            linkText: feature_2.linkText,
            link: featureLinksMapper[feature_2.key],
            icon: feature_2.icon,
            title: feature_2.title,
            onLinkClick: ()=>onLinkClick(feature_2.key),
            key: feature_2.key
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($lOHzS))),
        onClick: openLearnMoreVideo
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c48461bf82b3a37e$var$i18n.videoButtonText))))))));
    let t28;
    if ($[68] !== T1 || $[69] !== t27) {
        t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T1, null, t27);
        $[68] = T1;
        $[69] = t27;
        $[70] = t28;
    } else t28 = $[70];
    let t29;
    if ($[71] !== T0 || $[72] !== t24.FLYWHEEL_ENGAGEMENT || $[73] !== t26 || $[74] !== t28) {
        t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            attribution: t24.FLYWHEEL_ENGAGEMENT
        }, t26, t28);
        $[71] = T0;
        $[72] = t24.FLYWHEEL_ENGAGEMENT;
        $[73] = t26;
        $[74] = t28;
        $[75] = t29;
    } else t29 = $[75];
    return t29;
} : ({ onClose: onClose, stop: stop, onCloseComplete: onCloseComplete, modalTrigger: modalTrigger = "onboarding" })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(true);
    const [isLearnMoreVideoOpen, setIsLearnMoreVideoIsOpen] = (0, $42omo.useState)(false);
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { isCompanyHubEntryPointEnabled: isCompanyHubEntryPointEnabled } = (0, $7CeAz.useIsCompanyHubEnabled)();
    const currentSpaceKey = (0, $cLo2u.useSpaceKey)();
    const { data: { personalSpace: personalSpace, popularSpaces: popularSpaces, starredSpace: starredSpace, recentSpaces: recentSpaces } = {}, error: error } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query OnboardingManualTrialModalQuery{personalSpace:confluence_atlassianUser(current:true){id confluence{hasPersonalSpace space{id alias}}}popularSpaces:popularFeed(first:25){nodes{content{id space{id alias type}}}}starredSpace:spaces(favourite:true first:1 status:"current"){nodes{id alias}}recentSpaces:recentlyViewedSpaces{id alias}}`);
    const personalSpaceKey = personalSpace?.confluence?.hasPersonalSpace && personalSpace?.confluence?.space?.alias || undefined;
    const popularSpace = popularSpaces?.nodes.find((node)=>node.content?.space?.type !== 'system');
    const popularSpaceKey = popularSpace?.content?.space?.alias || undefined;
    const starredSpaceKey = starredSpace?.nodes?.[0]?.alias || undefined;
    const recentSpaceKey = recentSpaces?.[0]?.alias || undefined;
    if (error && !(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    const premiumFeatureDeeplinks = (0, $42omo.useMemo)(()=>{
        return new (0, $168e181c3998994c$export$d213136284bb1cdf)({
            personalSpaceKey: personalSpaceKey,
            popularSpaceKey: popularSpaceKey,
            starredSpaceKey: starredSpaceKey,
            recentSpaceKey: recentSpaceKey,
            currentSpaceKey: currentSpaceKey || undefined
        });
    }, [
        personalSpaceKey,
        popularSpaceKey,
        starredSpaceKey,
        recentSpaceKey,
        currentSpaceKey
    ]);
    const featureLinksMapper = (0, $42omo.useMemo)(()=>{
        return {
            ["atlassianIntelligence"]: premiumFeatureDeeplinks.getAi(),
            ["teamCalendars"]: premiumFeatureDeeplinks.getTeamCalendars(),
            ["companyHub"]: premiumFeatureDeeplinks.getCompanyHub({
                isCompanyHubEnabled: isCompanyHubEntryPointEnabled
            }),
            ["unlimitedWhiteboards"]: premiumFeatureDeeplinks.getWhiteboard({
                source: $c48461bf82b3a37e$export$5478df32444b3540
            }),
            ["automation"]: isSiteAdmin ? premiumFeatureDeeplinks.getAutomationAdmin() : premiumFeatureDeeplinks.getAutomationEndUser(),
            ["missionControl"]: premiumFeatureDeeplinks.getMissionControl(),
            ["contentManager"]: premiumFeatureDeeplinks.getContentManager(),
            ["analytics"]: premiumFeatureDeeplinks.getAnalytics()
        };
    }, [
        isCompanyHubEntryPointEnabled,
        isSiteAdmin,
        premiumFeatureDeeplinks
    ]);
    const featuresToShow = $c48461bf82b3a37e$var$featuresMapper.filter((feature)=>isSiteAdmin && feature.showToAdmin || !isSiteAdmin && feature.showToEndUser);
    if ((0, $9wGTI.fg)('a4c_free_and_standard_editions')) {
        const automationIdx = featuresToShow.findIndex((feature_0)=>feature_0.key === "automation");
        featuresToShow.splice(automationIdx, 1);
    }
    const modalRef = (0, $42omo.useRef)(null);
    const { getDwellTime: getDwellTime } = (0, $fXbFR.usePopupDwellTime)(modalRef);
    const hasLinkEventFiredWithDwellTime = (0, $42omo.useRef)(false);
    const closeModal = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'ptoManualTrialModalCloseButton',
                source: $c48461bf82b3a37e$export$5478df32444b3540,
                attributes: {
                    dwellTime: getDwellTime(),
                    modalTrigger: modalTrigger
                }
            }
        }).fire();
        setIsOpen(false);
        onClose?.();
    }, [
        createAnalyticsEvent,
        getDwellTime,
        onClose,
        modalTrigger
    ]);
    const openLearnMoreVideo = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'premiumVideoModalButton',
                source: $c48461bf82b3a37e$export$5478df32444b3540,
                attributes: {
                    dwellTime: getDwellTime(),
                    modalTrigger: modalTrigger
                }
            }
        }).fire();
        setIsLearnMoreVideoIsOpen(true);
    }, [
        createAnalyticsEvent,
        getDwellTime,
        modalTrigger
    ]);
    const closeLearnMoreVideo = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'premiumVideoModalCloseButton',
                source: $c48461bf82b3a37e$export$5478df32444b3540,
                attributes: {
                    modalTrigger: modalTrigger
                }
            }
        }).fire();
        setIsLearnMoreVideoIsOpen(false);
    }, [
        createAnalyticsEvent,
        modalTrigger
    ]);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: $c48461bf82b3a37e$export$5478df32444b3540,
                attributes: {
                    isSiteAdmin: isSiteAdmin,
                    modalTrigger: modalTrigger
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isSiteAdmin,
        modalTrigger
    ]);
    const onLinkClick = (0, $42omo.useCallback)((feature_1)=>{
        let dwellTime = {};
        if (!hasLinkEventFiredWithDwellTime.current) {
            dwellTime = {
                dwellTime: getDwellTime()
            };
            hasLinkEventFiredWithDwellTime.current = true;
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'premiumFeatureDeeplink',
                source: $c48461bf82b3a37e$export$5478df32444b3540,
                attributes: {
                    feature: feature_1,
                    isSiteAdmin: isSiteAdmin,
                    ...dwellTime,
                    modalTrigger: modalTrigger
                }
            }
        }).fire();
        stop?.();
        modalTrigger === "onboarding" && (0, $17wUi.confluenceLocalStorageInstance).setItem($c48461bf82b3a37e$var$modalClosedLocalStorageKey, 'true');
    }, [
        createAnalyticsEvent,
        isSiteAdmin,
        stop,
        getDwellTime,
        modalTrigger
    ]);
    if (modalTrigger === "onboarding" && (0, $17wUi.confluenceLocalStorageInstance).getItem($c48461bf82b3a37e$var$modalClosedLocalStorageKey)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).FLYWHEEL_ENGAGEMENT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, isLearnMoreVideoOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dd6c5da567a6ff5f$export$41318e6dd18eedd1), {
        onClose: closeLearnMoreVideo
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        autoFocus: false,
        width: 752,
        shouldScrollInViewport: true,
        onCloseComplete: onCloseComplete
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        ref: modalRef,
        alignBlock: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $c48461bf82b3a37e$var$imageContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3Bn5C))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($3Bn5C))),
        // eslint-disable-next-line no-restricted-syntax
        alt: "Premium trial onboarding modal",
        className: (0, $gMc0m.default)([
            "_5ral1dfr _1tke1osq _1bsb93m8 _4t3i1kdj"
        ])
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        padding: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        onClick: closeModal,
        label: "Close Modal"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        paddingInline: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "medium",
        as: "h1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c48461bf82b3a37e$var$i18n.modalTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c48461bf82b3a37e$var$i18n.modalDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.300"
    }, featuresToShow.map((feature_2)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $01ec9082b70ec97f$export$a7b06bfba60a8a78), {
            label: feature_2.key,
            bodyText: feature_2.bodyText,
            linkText: feature_2.linkText,
            link: featureLinksMapper[feature_2.key],
            icon: feature_2.icon,
            title: feature_2.title,
            onLinkClick: ()=>onLinkClick(feature_2.key),
            key: feature_2.key
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($lOHzS))),
        onClick: openLearnMoreVideo
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c48461bf82b3a37e$var$i18n.videoButtonText))))))))));
};
function $c48461bf82b3a37e$var$_temp(node) {
    return node.content?.space?.type !== "system";
}
function $c48461bf82b3a37e$var$_temp2(feature_0) {
    return feature_0.key === "automation";
}









var $IdK2A = parcelRequire("IdK2A");


var $eXOow = parcelRequire("eXOow");


var $9iADO = parcelRequire("9iADO");


var $9eYxl = parcelRequire("9eYxl");


var $57I23 = parcelRequire("57I23");


var $3qv1u = parcelRequire("3qv1u");


var $oCj79 = parcelRequire("oCj79");






















var $hArLp = parcelRequire("hArLp");








var $bQm3c = parcelRequire("bQm3c");

const $c4cf80a532bda9d3$var$i18n = (0, $h82at.defineMessages)({
    questionTitleHalfwayThroughTrial: {
        id: "premium-onboarding.question-halfway-through-trial.title.pto2",
        defaultMessage: "What do you think of Premium features so far?"
    },
    usefulButton: {
        id: "premium-onboarding.useful.button.pto2",
        defaultMessage: "\uD83D\uDC4D Useful"
    },
    notUsefulButton: {
        id: "premium-onboarding.not-useful.button.pto2",
        defaultMessage: "\uD83D\uDC4E Not useful"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c4cf80a532bda9d3$var$SurveyContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt41pyq _zulputpp _2rko1qi0 _11q715s3 _1e0c1txw _2lx21bp4",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41pyq _zulputpp _2rko1qi0 _11q715s3 _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $c4cf80a532bda9d3$var$ButtonGroupWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1o8l",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
});
const $c4cf80a532bda9d3$export$353ef337617fae9c = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(31);
    const { stopShowingSurvey: stopShowingSurvey, totalFeaturesUsed: totalFeaturesUsed, trialDaysLeft: trialDaysLeft, isSiteAdmin: isSiteAdmin, pto2Attributes: pto2Attributes, isPTORTEnabled: t1 } = t0;
    const isPTORTEnabled = t1 === undefined ? false : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    let t2;
    let t3;
    if ($[0] !== activationId || $[1] !== createAnalyticsEvent || $[2] !== isPTORTEnabled || $[3] !== isSiteAdmin || $[4] !== pto2Attributes || $[5] !== totalFeaturesUsed || $[6] !== trialDaysLeft) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "rendered",
                    actionSubject: "premFeaturesSurvey",
                    source: "premiumTrialOnboardingModal",
                    attributes: {
                        trialDaysLeft: trialDaysLeft,
                        isSiteAdmin: isSiteAdmin,
                        numPremiumFeaturesUsed: totalFeaturesUsed,
                        activationId: activationId,
                        ...pto2Attributes,
                        isPTORTEnabled: isPTORTEnabled
                    }
                }
            }).fire();
        };
        t3 = [
            createAnalyticsEvent,
            totalFeaturesUsed,
            trialDaysLeft,
            isSiteAdmin,
            activationId,
            pto2Attributes,
            isPTORTEnabled
        ];
        $[0] = activationId;
        $[1] = createAnalyticsEvent;
        $[2] = isPTORTEnabled;
        $[3] = isSiteAdmin;
        $[4] = pto2Attributes;
        $[5] = totalFeaturesUsed;
        $[6] = trialDaysLeft;
        $[7] = t2;
        $[8] = t3;
    } else {
        t2 = $[7];
        t3 = $[8];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[9] !== activationId || $[10] !== createAnalyticsEvent || $[11] !== isPTORTEnabled || $[12] !== pto2Attributes || $[13] !== stopShowingSurvey || $[14] !== totalFeaturesUsed || $[15] !== trialDaysLeft) {
        t4 = (usefulnessFeedback)=>{
            stopShowingSurvey();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "premFeaturesSurvey",
                    source: "premiumTrialOnboardingModal",
                    attributes: {
                        activationId: activationId,
                        trialDaysLeft: trialDaysLeft,
                        numPremiumFeaturesUsed: totalFeaturesUsed,
                        usefulnessFeedback: usefulnessFeedback,
                        ...pto2Attributes,
                        isPTORTEnabled: isPTORTEnabled
                    }
                }
            }).fire();
        };
        $[9] = activationId;
        $[10] = createAnalyticsEvent;
        $[11] = isPTORTEnabled;
        $[12] = pto2Attributes;
        $[13] = stopShowingSurvey;
        $[14] = totalFeaturesUsed;
        $[15] = trialDaysLeft;
        $[16] = t4;
    } else t4 = $[16];
    const onClickUsefulnessFeedback = t4;
    let t5;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            size: "xsmall",
            as: "h2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c4cf80a532bda9d3$var$i18n.questionTitleHalfwayThroughTrial));
        $[17] = t5;
    } else t5 = $[17];
    let t6;
    if ($[18] !== onClickUsefulnessFeedback) {
        t6 = ()=>onClickUsefulnessFeedback("yes");
        $[18] = onClickUsefulnessFeedback;
        $[19] = t6;
    } else t6 = $[19];
    let t7;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c4cf80a532bda9d3$var$i18n.usefulButton);
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== t6) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "primary",
            onClick: t6
        }, t7);
        $[21] = t6;
        $[22] = t8;
    } else t8 = $[22];
    let t9;
    if ($[23] !== onClickUsefulnessFeedback) {
        t9 = ()=>onClickUsefulnessFeedback("no");
        $[23] = onClickUsefulnessFeedback;
        $[24] = t9;
    } else t9 = $[24];
    let t10;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c4cf80a532bda9d3$var$i18n.notUsefulButton);
        $[25] = t10;
    } else t10 = $[25];
    let t11;
    if ($[26] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            onClick: t9,
            appearance: "default"
        }, t10);
        $[26] = t9;
        $[27] = t11;
    } else t11 = $[27];
    let t12;
    if ($[28] !== t11 || $[29] !== t8) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c4cf80a532bda9d3$var$SurveyContainer, null, t5, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c4cf80a532bda9d3$var$ButtonGroupWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, t8, t11)));
        $[28] = t11;
        $[29] = t8;
        $[30] = t12;
    } else t12 = $[30];
    return t12;
} : ({ stopShowingSurvey: stopShowingSurvey, totalFeaturesUsed: totalFeaturesUsed, trialDaysLeft: trialDaysLeft, isSiteAdmin: isSiteAdmin, pto2Attributes: pto2Attributes, isPTORTEnabled: isPTORTEnabled = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'rendered',
                actionSubject: 'premFeaturesSurvey',
                source: 'premiumTrialOnboardingModal',
                attributes: {
                    trialDaysLeft: trialDaysLeft,
                    isSiteAdmin: isSiteAdmin,
                    numPremiumFeaturesUsed: totalFeaturesUsed,
                    activationId: activationId,
                    ...pto2Attributes,
                    isPTORTEnabled: isPTORTEnabled
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        totalFeaturesUsed,
        trialDaysLeft,
        isSiteAdmin,
        activationId,
        pto2Attributes,
        isPTORTEnabled
    ]);
    const onClickUsefulnessFeedback = (0, $42omo.useCallback)((usefulnessFeedback)=>{
        stopShowingSurvey();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'premFeaturesSurvey',
                source: 'premiumTrialOnboardingModal',
                attributes: {
                    activationId: activationId,
                    trialDaysLeft: trialDaysLeft,
                    numPremiumFeaturesUsed: totalFeaturesUsed,
                    usefulnessFeedback: usefulnessFeedback,
                    ...pto2Attributes,
                    isPTORTEnabled: isPTORTEnabled
                }
            }
        }).fire();
    }, [
        stopShowingSurvey,
        createAnalyticsEvent,
        activationId,
        trialDaysLeft,
        totalFeaturesUsed,
        pto2Attributes,
        isPTORTEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c4cf80a532bda9d3$var$SurveyContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "xsmall",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c4cf80a532bda9d3$var$i18n.questionTitleHalfwayThroughTrial)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c4cf80a532bda9d3$var$ButtonGroupWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "primary",
        onClick: ()=>onClickUsefulnessFeedback('yes')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c4cf80a532bda9d3$var$i18n.usefulButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        onClick: ()=>onClickUsefulnessFeedback('no'),
        appearance: "default"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c4cf80a532bda9d3$var$i18n.notUsefulButton)))));
};



var $kkAiW = parcelRequire("kkAiW");


var $dc00l = parcelRequire("dc00l");


var $bC5Yk = parcelRequire("bC5Yk");

const $b6cb7c58969a7b11$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    modalTitle: {
        id: "premium-onboarding.modal.title",
        defaultMessage: "Welcome to your Premium trial"
    },
    modalBodyText: {
        id: "premium-onboarding.modal.body.text",
        defaultMessage: "Explore Confluence\u2019s most powerful features"
    },
    modalBodyTextPTO2: {
        id: "premium-onboarding.modal.body.text.pto2",
        defaultMessage: "Get started by exploring our 5 most popular features."
    },
    modalBodyTextPTO2WithoutAutomation: {
        id: "premium-onboarding.modal.body.text.pto2.no.automation",
        defaultMessage: "Get started by exploring our 4 most popular features."
    },
    modalTitleBeginningOfTrial: {
        id: "premium-onboarding.modal-beginning-of-trial.title.pto2",
        defaultMessage: "Your Premium feature guide"
    },
    modalTitleHalfwayThroughTrial: {
        id: "premium-onboarding.modal-halfway-through-trial.title.pto2",
        defaultMessage: "You have {daysLeft, plural, one {# day} other {# days}} left on your Premium trial \uD83C\uDF89"
    },
    modalBodyTextBeginningOfTrial: {
        id: "premium-onboarding.modal-beginning-of-trial.body.text.pto2",
        defaultMessage: "Features will get a checkmark once you\u2019ve used them."
    },
    modalBodyTextHalfwayThroughTrialSentence1: {
        id: "premium-onboarding.modal-halfway-through-trial.body.text.sentence1.pto2",
        defaultMessage: "You\u2019ve used <b>{count}</b> of Premium\u2019s most popular features."
    },
    modalBodyTextHalfwayThroughTrialSentence2: {
        id: "premium-onboarding.modal-halfway-through-trial.body.text.sentence2.pto2",
        defaultMessage: "Get the most out of your trial by exploring features you haven\u2019t tried yet."
    },
    modalBodyTextHalfwayThroughTrialSentence3: {
        id: "premium-onboarding.modal-halfway-through-trial.body.text.sentence3.pto2",
        defaultMessage: "You\u2019ve used <b>all</b> of Premium\u2019s most popular features."
    },
    toggleTitlePTO2: {
        id: "premium-onboarding.toggle.title.pto2",
        defaultMessage: "Highlight Premium features in Confluence"
    },
    toggleBodyText: {
        id: "premium-onboarding.toggle.body.text",
        defaultMessage: "We\u2019ll help you identify Premium features with a label."
    },
    buttonText: {
        id: "premium-onboarding.button.text",
        defaultMessage: "Explore features"
    },
    analyticsTitle: {
        id: "premium-onboarding.analytics.title",
        defaultMessage: "Analytics"
    },
    analyticsBodyTextPTO2: {
        id: "premium-onboarding.analytics.body.text.pto2",
        defaultMessage: "See user engagement and views at the site, space, and content level."
    },
    teamCalendarsTitle: {
        id: "premium-onboarding.team-calendars.title",
        defaultMessage: "Team calendars"
    },
    teamCalendarsBodyText: {
        id: "premium-onboarding.team-calendars.body.text",
        defaultMessage: "Keep one single source of truth for your team\u2019s schedules and due dates."
    },
    unlimitedStorageAndWhiteboardsTitle: {
        id: "premium-onboarding.unlimited-storage-and-whiteboards.title.pto2",
        defaultMessage: "Unlimited storage and whiteboards"
    },
    whiteboardBodyText: {
        id: "premium-onboarding.whiteboard.body.text",
        defaultMessage: "Never run out of space to turn ideas into actions."
    },
    automationTitle: {
        id: "premium-onboarding.automation.title",
        defaultMessage: "Automation"
    },
    automationBodyText: {
        id: "premium-onboarding.automation.body.text",
        defaultMessage: "Save time by creating rules to change content status, create a Jira task, and more."
    },
    advancedPermissionsTitle: {
        id: "premium-onboarding.advanced.permissions.title",
        defaultMessage: "Advanced permissions"
    },
    advancedPermissionsBodyTextPTO2: {
        id: "premium-onboarding.advanced.permissions.body.text.pto2",
        defaultMessage: "Review permission-related issues and make sure your team has proper access to content."
    },
    additionalFeaturesTitle: {
        id: "premium-onboarding.title.additional.features",
        defaultMessage: "Plus:"
    }
});
const $b6cb7c58969a7b11$var$NUMBER_OF_PREMIUM_FEATURES = 4;
const $b6cb7c58969a7b11$var$SURVEY_KEY = 'premium.trial.features.usefulness.survey'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b6cb7c58969a7b11$var$Layout = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _2lx2vrvc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b6cb7c58969a7b11$var$ImageContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1bsb1wdt _uhwn1ris",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1wdt _uhwn1ris",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b6cb7c58969a7b11$var$TextArea = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1bsbdgin _bfhk15cr",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsbdgin _bfhk15cr",
            __cmplp.className
        ])
    });
});
const $b6cb7c58969a7b11$var$textAreaBodyStyles = (0, $ecnYn.xcss)({
    paddingRight: 'space.500',
    paddingBottom: 'space.300',
    paddingLeft: 'space.500'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b6cb7c58969a7b11$var$SecondTitle = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $cO1el.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_19pku2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = (0, $cO1el.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b6cb7c58969a7b11$var$CloseButton = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_u5f31b66 _ca0qpxbi _y3gnusic _uhwn1ris",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_u5f31b66 _ca0qpxbi _y3gnusic _uhwn1ris",
            __cmplp.className
        ])
    });
});
const $b6cb7c58969a7b11$var$listItemWrapperStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.300',
    marginBottom: 'space.300'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b6cb7c58969a7b11$var$ButtonWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1bsb1osq _vchh1g6k _y3gnusic",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _vchh1g6k _y3gnusic",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b6cb7c58969a7b11$var$ToggleWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1bsb1osq _vchh1g6k _1e0c1txw _otyr1ejb",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _vchh1g6k _1e0c1txw _otyr1ejb",
            __cmplp.className
        ])
    });
});
const $b6cb7c58969a7b11$var$ToggleContent = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "label" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2lx21bp4",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2lx21bp4",
            __cmplp.className
        ])
    });
});
const $b6cb7c58969a7b11$var$togglePaddingStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.100',
    paddingRight: 'space.150'
});
var $b6cb7c58969a7b11$export$a246ba0e876a484d = /*#__PURE__*/ function(TriggerFrom) {
    TriggerFrom["PILL"] = "pill";
    TriggerFrom["ONBOARDING"] = "onboarding";
    TriggerFrom["MID_TRIAL_ONBOARDING"] = "midTrialOnboarding";
    TriggerFrom["HOME_ONBOARDING_TAKEOVER_V2"] = "homeOnboardingTakeoverV2";
    return TriggerFrom;
}({});
const $b6cb7c58969a7b11$var$ModalComponent = ({ isSiteAdmin: isSiteAdmin, onClose: onClose, stop: stop, triggerFrom: triggerFrom, daysLeft: daysLeft = 0, source: source = 'premiumTrialOnboardingModal' })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(true);
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [{ isSpotlightCheckEnabled: isSpotlightCheckEnabled }, { enableSpotlightCheck: enableSpotlightCheck }] = (0, $IdK2A.useShouldCheckEligibilityForSpotlight)();
    const [showSurvey, stopShowingSurvey] = (0, $9oxdN.useFeatureDiscovery)($b6cb7c58969a7b11$var$SURVEY_KEY);
    const { isPTORTEnabled: isPTORTEnabled, loading: isPTORTEnabledLoading } = (0, $bC5Yk.useIsPremiumOnboardingFeatureDiscoveryEnabled)({
        shouldCheckIsInTrial: false
    });
    const { showMidTrialModal: showPTORTMidTrialModal } = (0, $dc00l.usePTOModalVisibilityOnReverseTrial)({
        isPTORTEnabled: isPTORTEnabled,
        isSiteAdmin: isSiteAdmin
    });
    const modalRef = (0, $42omo.useRef)(null);
    const { getDwellTime: getDwellTime } = (0, $fXbFR.usePopupDwellTime)(modalRef);
    const isTrialHalfWayThrough = isPTORTEnabled ? showPTORTMidTrialModal : (0, $kkAiW.getIsTrialInLast15Days)(daysLeft);
    const isTriggeredFromPillOrMidTrial = triggerFrom !== "onboarding";
    let modalBody = (0, $9wGTI.fg)('a4c_free_and_standard_editions') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $b6cb7c58969a7b11$export$a7357cdd1f0b0168.modalBodyTextPTO2WithoutAutomation) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $b6cb7c58969a7b11$export$a7357cdd1f0b0168.modalBodyTextPTO2);
    let modalTitle = $b6cb7c58969a7b11$export$a7357cdd1f0b0168.modalTitle;
    if (isTriggeredFromPillOrMidTrial) {
        modalBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $b6cb7c58969a7b11$export$a7357cdd1f0b0168.modalBodyTextBeginningOfTrial);
        modalTitle = $b6cb7c58969a7b11$export$a7357cdd1f0b0168.modalTitleBeginningOfTrial;
    }
    const sharedFeaturesMapper = [
        {
            title: $b6cb7c58969a7b11$export$a7357cdd1f0b0168.analyticsTitle,
            bodyText: $b6cb7c58969a7b11$export$a7357cdd1f0b0168.analyticsBodyTextPTO2,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($cyLm6))),
            featureKey: (0, $oCj79.PremiumFeatureKey).ANALYTICS
        },
        {
            title: $b6cb7c58969a7b11$export$a7357cdd1f0b0168.teamCalendarsTitle,
            bodyText: $b6cb7c58969a7b11$export$a7357cdd1f0b0168.teamCalendarsBodyText,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))),
            featureKey: (0, $oCj79.PremiumFeatureKey).TEAM_CALENDAR
        },
        {
            title: $b6cb7c58969a7b11$export$a7357cdd1f0b0168.unlimitedStorageAndWhiteboardsTitle,
            bodyText: $b6cb7c58969a7b11$export$a7357cdd1f0b0168.whiteboardBodyText,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
            featureKey: (0, $oCj79.PremiumFeatureKey).UNLIMITED_STORAGE
        },
        {
            title: $b6cb7c58969a7b11$export$a7357cdd1f0b0168.automationTitle,
            bodyText: $b6cb7c58969a7b11$export$a7357cdd1f0b0168.automationBodyText,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($isYda))),
            featureKey: (0, $oCj79.PremiumFeatureKey).AUTOMATION
        },
        {
            title: $b6cb7c58969a7b11$export$a7357cdd1f0b0168.advancedPermissionsTitle,
            bodyText: $b6cb7c58969a7b11$export$a7357cdd1f0b0168.advancedPermissionsBodyTextPTO2,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))),
            featureKey: (0, $oCj79.PremiumFeatureKey).ADVANCED_PERMISSIONS
        }
    ];
    if ((0, $9wGTI.fg)('a4c_free_and_standard_editions')) {
        const automationIdx = sharedFeaturesMapper.findIndex((feature)=>feature.title === $b6cb7c58969a7b11$export$a7357cdd1f0b0168.automationTitle);
        sharedFeaturesMapper.splice(automationIdx, 1);
    }
    const { updatedSharedFeaturesMapperWithCheckIconStatus: updatedSharedFeaturesMapperWithCheckIconStatus, totalFeaturesUsed: totalFeaturesUsed, pto2Attributes: pto2Attributes } = (0, $3qv1u.usePremiumFeatureUsageIcon)({
        shouldUpdate: isTriggeredFromPillOrMidTrial,
        rawSharedFeaturesMapper: sharedFeaturesMapper
    });
    (0, $42omo.useEffect)(()=>{
        triggerFrom === "onboarding" && (0, $eXOow.setIsPremiumOnboardingHappened)(true);
    }, [
        triggerFrom
    ]);
    const areAllFeaturesUsed = totalFeaturesUsed === $b6cb7c58969a7b11$var$NUMBER_OF_PREMIUM_FEATURES;
    if (isTrialHalfWayThrough && isTriggeredFromPillOrMidTrial) {
        modalTitle = $b6cb7c58969a7b11$export$a7357cdd1f0b0168.modalTitleHalfwayThroughTrial;
        modalBody = areAllFeaturesUsed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
            ...$b6cb7c58969a7b11$export$a7357cdd1f0b0168.modalBodyTextHalfwayThroughTrialSentence3,
            values: {
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
            ...$b6cb7c58969a7b11$export$a7357cdd1f0b0168.modalBodyTextHalfwayThroughTrialSentence1,
            values: {
                count: totalFeaturesUsed,
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
            }
        }), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $b6cb7c58969a7b11$export$a7357cdd1f0b0168.modalBodyTextHalfwayThroughTrialSentence2));
    }
    const closeModal = (0, $42omo.useCallback)(async (actionSubjectId = '')=>{
        actionSubjectId && triggerFrom !== "onboarding" && createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: {
                    dwellTime: getDwellTime(),
                    isPTORTEnabled: isPTORTEnabled,
                    triggerFrom: triggerFrom
                }
            }
        }).fire();
        onClose?.();
        stop?.();
        setIsOpen(false);
        if (isSpotlightCheckEnabled === false && triggerFrom === "onboarding") await enableSpotlightCheck();
    }, [
        createAnalyticsEvent,
        source,
        getDwellTime,
        isPTORTEnabled,
        triggerFrom,
        onClose,
        stop,
        isSpotlightCheckEnabled,
        enableSpotlightCheck
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isPTORTEnabledLoading && triggerFrom !== "onboarding") createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: source,
                attributes: {
                    isSiteAdmin: isSiteAdmin,
                    triggeredFrom: triggerFrom === "pill" ? 'featureGuide' : triggerFrom,
                    daysLeft: daysLeft,
                    numPremiumFeaturesUsed: totalFeaturesUsed,
                    ...pto2Attributes,
                    isPTORTEnabled: isPTORTEnabled
                }
            }
        }).fire();
         //making sure that this event gets fired only once
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isPTORTEnabledLoading
    ]);
    const handleErrorBoundary = ()=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'unhandledPremiumTrialError',
                source: source,
                actionSubject: 'ui',
                attributes: {
                    attribution: (0, $3IBnw.Attribution).FLYWHEEL_ENGAGEMENT
                }
            }
        }).fire();
    };
    if (triggerFrom === "onboarding") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c48461bf82b3a37e$export$ee19e0d1f60d67c2), {
        onClose: closeModal,
        stop: stop
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).FLYWHEEL_ENGAGEMENT,
        onError: handleErrorBoundary
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, isOpen && // To ensure that the close button isn't in focus when the modal is opened, disable auto focus on the modal
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        onClose: ()=>closeModal('premiumTrialOnboardingModalCloseButton'),
        autoFocus: false,
        width: 720
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b6cb7c58969a7b11$var$Layout, {
        ref: modalRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b6cb7c58969a7b11$var$ImageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9iADO))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($9iADO))),
        alt: "",
        className: (0, $gMc0m.default)([
            "_5ral1dfr _1tke1osq _1bsb1wdt _4t3i1nzo"
        ])
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b6cb7c58969a7b11$var$TextArea, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b6cb7c58969a7b11$var$CloseButton, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "link",
        onClick: ()=>closeModal('premiumTrialOnboardingModalCloseButton')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
        label: "Close Modal",
        color: "var(--ds-text, #292A2E)"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b6cb7c58969a7b11$var$textAreaBodyStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "medium",
        as: "h1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
        ...modalTitle,
        values: {
            daysLeft: daysLeft
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b6cb7c58969a7b11$var$SecondTitle, {
        as: "h2",
        size: isTrialHalfWayThrough ? 'small' : 'xxsmall'
    }, modalBody), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b6cb7c58969a7b11$var$listItemWrapperStyles
    }, Object.keys(updatedSharedFeaturesMapperWithCheckIconStatus).filter((key)=>!(updatedSharedFeaturesMapperWithCheckIconStatus[key].featureKey === (0, $oCj79.PremiumFeatureKey).UNLIMITED_STORAGE && isTriggeredFromPillOrMidTrial)).map((key)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9eYxl.ListItem), {
            key: key,
            bodyText: updatedSharedFeaturesMapperWithCheckIconStatus[key].bodyText,
            checkIconStatus: updatedSharedFeaturesMapperWithCheckIconStatus[key].checkIconStatus,
            icon: updatedSharedFeaturesMapperWithCheckIconStatus[key].icon,
            title: updatedSharedFeaturesMapperWithCheckIconStatus[key].title
        }))), isTriggeredFromPillOrMidTrial ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b6cb7c58969a7b11$var$ToggleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b6cb7c58969a7b11$var$togglePaddingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $57I23.PremiumFeatureHighlightToggle), {
        id: "prem-feature-highlight-toggle-modal",
        source: "premTrialOnboardingModal",
        isPTORTEnabled: isPTORTEnabled
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b6cb7c58969a7b11$var$ToggleContent, {
        htmlFor: "prem-feature-highlight-toggle-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $b6cb7c58969a7b11$export$a7357cdd1f0b0168.toggleTitlePTO2)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        as: "p",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $b6cb7c58969a7b11$export$a7357cdd1f0b0168.toggleBodyText)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b6cb7c58969a7b11$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dqdrq.GradientCTAButton), {
        onClick: ()=>closeModal('premiumTrialOnboardingModalExploreFeatures')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $b6cb7c58969a7b11$export$a7357cdd1f0b0168.buttonText)))), isTriggeredFromPillOrMidTrial && showSurvey && isTrialHalfWayThrough && totalFeaturesUsed > 0 && !isPTORTEnabledLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4cf80a532bda9d3$export$353ef337617fae9c), {
        trialDaysLeft: daysLeft,
        totalFeaturesUsed: totalFeaturesUsed,
        stopShowingSurvey: stopShowingSurvey,
        isSiteAdmin: isSiteAdmin,
        pto2Attributes: pto2Attributes,
        isPTORTEnabled: isPTORTEnabled
    })))))));
};
const $b6cb7c58969a7b11$export$936374c058c289fa = (0, $f7Bnv.withIsSiteAdmin)($b6cb7c58969a7b11$var$ModalComponent);
module.exports["i18n"] = $b6cb7c58969a7b11$export$a7357cdd1f0b0168;
module.exports["TriggerFrom"] = $b6cb7c58969a7b11$export$a246ba0e876a484d;
module.exports["PremiumTrialOnboardingModal"] = $b6cb7c58969a7b11$export$936374c058c289fa;

});

parcelRegister("3Bn5C", function(module, exports) {
module.exports = new URL("Illustration.bc0cbd7b.svg", import.meta.url).toString();

});

parcelRegister("IdK2A", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $340fa5240b90217d$var$initialState = {
    isSpotlightCheckEnabled: false
};
const $340fa5240b90217d$var$actions = {
    disableSpotlightCheck: ()=>({ setState: setState })=>{
            setState({
                isSpotlightCheckEnabled: false
            });
        },
    enableSpotlightCheck: ()=>({ setState: setState })=>{
            setState({
                isSpotlightCheckEnabled: true
            });
        }
};
const $340fa5240b90217d$var$store = (0, $1P1Tu.createStore)({
    initialState: $340fa5240b90217d$var$initialState,
    actions: $340fa5240b90217d$var$actions,
    name: 'SpotlightEligibilityStore'
});
const $340fa5240b90217d$export$5d3e9044de751b4 = (0, $9zUhf.createHook)($340fa5240b90217d$var$store);
module.exports["useShouldCheckEligibilityForSpotlight"] = $340fa5240b90217d$export$5d3e9044de751b4;

});

parcelRegister("eXOow", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $df3e507aeb28cc8c$export$a521def1ea8b0037 = (0, $1UApO.keys).PTO_PHASE_TWO_SPOTLIGHT_TARGET;
const $df3e507aeb28cc8c$export$7fe6635e9bc84df7 = (initialLoading = false)=>{
    return initialLoading ? (0, $17wUi.confluenceLocalStorageInstance).getItem($df3e507aeb28cc8c$export$a521def1ea8b0037) === null : (0, $17wUi.confluenceLocalStorageInstance).getItem($df3e507aeb28cc8c$export$a521def1ea8b0037) === 'false';
};
const $df3e507aeb28cc8c$export$3aed5f8f1690ecaf = (isPremiumOnboardingHappened)=>{
    try {
        (0, $17wUi.confluenceLocalStorageInstance).setItem($df3e507aeb28cc8c$export$a521def1ea8b0037, String(isPremiumOnboardingHappened));
        return true;
    } catch (err) {
        return false;
    }
};
module.exports["PTO_PHASE_TWO_SPOTLIGHT_TARGET"] = $df3e507aeb28cc8c$export$a521def1ea8b0037;
module.exports["getIsPremiumOnboardingHappened"] = $df3e507aeb28cc8c$export$7fe6635e9bc84df7;
module.exports["setIsPremiumOnboardingHappened"] = $df3e507aeb28cc8c$export$3aed5f8f1690ecaf;

});

parcelRegister("9iADO", function(module, exports) {
module.exports = new URL("Illustration.bc0cbd7b.svg", import.meta.url).toString();

});

parcelRegister("9eYxl", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $hiS1z = parcelRequire("hiS1z");


var $imt6g = parcelRequire("imt6g");


var $gdv5Z = parcelRequire("gdv5Z");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $14f5b99b946bec62$var$Wrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1bsb1pna _1e0c1txw _19pkutpp _otyrutpp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1pna _1e0c1txw _19pkutpp _otyrutpp",
            __cmplp.className
        ])
    });
});
const $14f5b99b946bec62$var$CoreCheckIconWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_19pkv77o _ca0qu2gc _u5f3utpp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkv77o _ca0qu2gc _u5f3utpp",
            __cmplp.className
        ])
    });
});
const $14f5b99b946bec62$var$CoreIconBackground = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rko1qi0 _bfhk19ip _4t3i14no _1bsb14no _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1qi0 _bfhk19ip _4t3i14no _1bsb14no _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $14f5b99b946bec62$var$ContentWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1bsb1dty _2lx21bp4",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1dty _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $14f5b99b946bec62$var$TextAreaTitle = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8fhey _k48pwu06",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey _k48pwu06",
            __cmplp.className
        ])
    });
});
const $14f5b99b946bec62$var$TextAreaBody = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8fhey",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey",
            __cmplp.className
        ])
    });
});
var $14f5b99b946bec62$export$7beb9f7ae1438f78 = /*#__PURE__*/ function(CheckIconStatus) {
    CheckIconStatus[CheckIconStatus["CHECKED"] = 0] = "CHECKED";
    CheckIconStatus[CheckIconStatus["UNCHECKED"] = 1] = "UNCHECKED";
    CheckIconStatus[CheckIconStatus["NOT_RENDERED"] = 2] = "NOT_RENDERED";
    return CheckIconStatus;
}({});
const $14f5b99b946bec62$export$a7b06bfba60a8a78 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { icon: icon, title: title, bodyText: bodyText, checkIconStatus: t1 } = t0;
    const checkIconStatus = t1 === undefined ? 2 : t1;
    const Icon = icon;
    let t2;
    if ($[0] !== checkIconStatus) {
        t2 = checkIconStatus === 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($14f5b99b946bec62$var$CoreCheckIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($imt6g))), {
            label: "",
            testId: "unchecked-icon",
            spacing: "spacious",
            color: "var(--ds-icon, #292A2E)"
        }));
        $[0] = checkIconStatus;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== checkIconStatus) {
        t3 = checkIconStatus === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($14f5b99b946bec62$var$CoreCheckIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($imt6g))), {
            label: "",
            testId: "checked-icon",
            spacing: "spacious",
            color: "var(--ds-icon-success, #6A9A23)"
        }));
        $[2] = checkIconStatus;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== Icon) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingBlockStart: "space.050",
            paddingInlineEnd: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($14f5b99b946bec62$var$CoreIconBackground, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: "",
            color: "var(--ds-icon-information, #357DE8)"
        })));
        $[4] = Icon;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== title) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($14f5b99b946bec62$var$TextAreaTitle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), title));
        $[6] = title;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== bodyText) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($14f5b99b946bec62$var$TextAreaBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), bodyText));
        $[8] = bodyText;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== t5 || $[11] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($14f5b99b946bec62$var$ContentWrapper, null, t5, t6);
        $[10] = t5;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($14f5b99b946bec62$var$Wrapper, null, t2, t3, t4, t7);
        $[13] = t2;
        $[14] = t3;
        $[15] = t4;
        $[16] = t7;
        $[17] = t8;
    } else t8 = $[17];
    return t8;
} : ({ icon: icon, title: title, bodyText: bodyText, checkIconStatus: checkIconStatus = 2 })=>{
    const Icon = icon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($14f5b99b946bec62$var$Wrapper, null, checkIconStatus === 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($14f5b99b946bec62$var$CoreCheckIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($imt6g))), {
        label: "",
        testId: "unchecked-icon",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    })), checkIconStatus === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($14f5b99b946bec62$var$CoreCheckIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($imt6g))), {
        label: "",
        testId: "checked-icon",
        spacing: "spacious",
        color: "var(--ds-icon-success, #6A9A23)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        paddingBlockStart: "space.050",
        paddingInlineEnd: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($14f5b99b946bec62$var$CoreIconBackground, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: "",
        color: "var(--ds-icon-information, #357DE8)"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($14f5b99b946bec62$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($14f5b99b946bec62$var$TextAreaTitle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($14f5b99b946bec62$var$TextAreaBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), bodyText))));
};
module.exports["CheckIconStatus"] = $14f5b99b946bec62$export$7beb9f7ae1438f78;
module.exports["ListItem"] = $14f5b99b946bec62$export$a7b06bfba60a8a78;

});

parcelRegister("57I23", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $82gXq = parcelRequire("82gXq");


var $inPa6 = parcelRequire("inPa6");


var $5qxqN = parcelRequire("5qxqN");

var $54fd34cc72fbde8f$export$301e303bc8f43a54 = /*#__PURE__*/ function(PillTypeForToggleAnalytics) {
    PillTypeForToggleAnalytics["HAS_PAYMENT"] = "hasPayment";
    PillTypeForToggleAnalytics["NO_PAYMENT"] = "noPayment";
    PillTypeForToggleAnalytics["END_USER"] = "endUser";
    return PillTypeForToggleAnalytics;
}({});
const $54fd34cc72fbde8f$export$62b2f1ea744d5957 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { id: id, source: source, pillType: pillType, isPTORTEnabled: t1 } = t0;
    const isPTORTEnabled = t1 === undefined ? false : t1;
    const [t2, t3] = (0, $5qxqN.usePremiumFeatureHighlight)();
    const { isEnabled: isChecked } = t2;
    const { update: update } = t3;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t4;
    if ($[0] !== createAnalyticsEvent || $[1] !== isChecked || $[2] !== isPTORTEnabled || $[3] !== pillType || $[4] !== source || $[5] !== update) {
        t4 = async ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "toggle",
                    actionSubjectId: "premiumTrialOnboardingToggle",
                    attributes: {
                        prevState: isChecked,
                        currentState: !isChecked,
                        pillType: pillType || null,
                        isPTORTEnabled: isPTORTEnabled
                    },
                    source: source
                }
            }).fire();
            await update();
        };
        $[0] = createAnalyticsEvent;
        $[1] = isChecked;
        $[2] = isPTORTEnabled;
        $[3] = pillType;
        $[4] = source;
        $[5] = update;
        $[6] = t4;
    } else t4 = $[6];
    const handleChange = t4;
    let t5;
    if ($[7] !== handleChange || $[8] !== id || $[9] !== isChecked) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $82gXq.default), {
            id: id,
            isChecked: isChecked,
            onChange: handleChange
        });
        $[7] = handleChange;
        $[8] = id;
        $[9] = isChecked;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
} : ({ id: id, source: source, pillType: pillType, isPTORTEnabled: isPTORTEnabled = false })=>{
    const [{ isEnabled: isChecked }, { update: update }] = (0, $5qxqN.usePremiumFeatureHighlight)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleChange = async ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'toggle',
                actionSubjectId: 'premiumTrialOnboardingToggle',
                attributes: {
                    prevState: isChecked,
                    currentState: !isChecked,
                    pillType: pillType || null,
                    isPTORTEnabled: isPTORTEnabled
                },
                source: source
            }
        }).fire();
        await update();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $82gXq.default), {
        id: id,
        isChecked: isChecked,
        onChange: handleChange
    });
};
module.exports["PremiumFeatureHighlightToggle"] = $54fd34cc72fbde8f$export$62b2f1ea744d5957;

});

parcelRegister("3qv1u", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $9oxdN = parcelRequire("9oxdN");


var $9eYxl = parcelRequire("9eYxl");


var $oCj79 = parcelRequire("oCj79");

const $a9db61638509c9e5$export$4f2bb5b3a8eacebe = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { skip: t2 } = t1;
    const skip = t2 === undefined ? false : t2;
    const [isAdvancedPermissionsNeverUsed] = (0, $9oxdN.useFeatureDiscovery)((0, $oCj79.PremiumFeatureKey).ADVANCED_PERMISSIONS, skip);
    const [isAnalyticsNeverUsed] = (0, $9oxdN.useFeatureDiscovery)((0, $oCj79.PremiumFeatureKey).ANALYTICS, skip);
    const [isAutomationNeverUsed] = (0, $9oxdN.useFeatureDiscovery)((0, $oCj79.PremiumFeatureKey).AUTOMATION, skip);
    const [isTeamCalendarNeverUsed] = (0, $9oxdN.useFeatureDiscovery)((0, $oCj79.PremiumFeatureKey).TEAM_CALENDAR, skip);
    let featureUsageMapper;
    let t3;
    if ($[2] !== isAdvancedPermissionsNeverUsed || $[3] !== isAnalyticsNeverUsed || $[4] !== isAutomationNeverUsed || $[5] !== isTeamCalendarNeverUsed || $[6] !== skip) {
        featureUsageMapper = {
            [(0, $oCj79.PremiumFeatureKey).ADVANCED_PERMISSIONS]: isAdvancedPermissionsNeverUsed,
            [(0, $oCj79.PremiumFeatureKey).ANALYTICS]: isAnalyticsNeverUsed,
            [(0, $oCj79.PremiumFeatureKey).AUTOMATION]: isAutomationNeverUsed,
            [(0, $oCj79.PremiumFeatureKey).TEAM_CALENDAR]: isTeamCalendarNeverUsed
        };
        t3 = skip ? 0 : Object.values(featureUsageMapper).reduce($a9db61638509c9e5$var$_temp, 0);
        $[2] = isAdvancedPermissionsNeverUsed;
        $[3] = isAnalyticsNeverUsed;
        $[4] = isAutomationNeverUsed;
        $[5] = isTeamCalendarNeverUsed;
        $[6] = skip;
        $[7] = featureUsageMapper;
        $[8] = t3;
    } else {
        featureUsageMapper = $[7];
        t3 = $[8];
    }
    const totalFeaturesUsed = t3;
    let t4;
    if ($[9] !== featureUsageMapper || $[10] !== totalFeaturesUsed) {
        t4 = {
            featureUsageMapper: featureUsageMapper,
            totalFeaturesUsed: totalFeaturesUsed
        };
        $[9] = featureUsageMapper;
        $[10] = totalFeaturesUsed;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
} : ({ skip: skip = false } = {})=>{
    /**
   * if isFeatureNeverUsed is true, the feature has not been discovered
   * else the feature has been discovered
   */ const [isAdvancedPermissionsNeverUsed] = (0, $9oxdN.useFeatureDiscovery)((0, $oCj79.PremiumFeatureKey).ADVANCED_PERMISSIONS, /* skip */ skip);
    const [isAnalyticsNeverUsed] = (0, $9oxdN.useFeatureDiscovery)((0, $oCj79.PremiumFeatureKey).ANALYTICS, /* skip */ skip);
    const [isAutomationNeverUsed] = (0, $9oxdN.useFeatureDiscovery)((0, $oCj79.PremiumFeatureKey).AUTOMATION, /* skip */ skip);
    const [isTeamCalendarNeverUsed] = (0, $9oxdN.useFeatureDiscovery)((0, $oCj79.PremiumFeatureKey).TEAM_CALENDAR, /* skip */ skip);
    const featureUsageMapper = {
        [(0, $oCj79.PremiumFeatureKey).ADVANCED_PERMISSIONS]: isAdvancedPermissionsNeverUsed,
        [(0, $oCj79.PremiumFeatureKey).ANALYTICS]: isAnalyticsNeverUsed,
        [(0, $oCj79.PremiumFeatureKey).AUTOMATION]: isAutomationNeverUsed,
        [(0, $oCj79.PremiumFeatureKey).TEAM_CALENDAR]: isTeamCalendarNeverUsed
    };
    const totalFeaturesUsed = skip ? 0 : Object.values(featureUsageMapper).reduce((count, value)=>count + (value === false ? 1 : 0), 0);
    return {
        featureUsageMapper: featureUsageMapper,
        totalFeaturesUsed: totalFeaturesUsed
    };
};
const $a9db61638509c9e5$export$27c06a9fba830ff1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { shouldUpdate: shouldUpdate, rawSharedFeaturesMapper: rawSharedFeaturesMapper } = t0;
    const { totalFeaturesUsed: totalFeaturesUsed, featureUsageMapper: featureUsageMapper } = $a9db61638509c9e5$export$4f2bb5b3a8eacebe();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            [(0, $oCj79.PremiumFeatureKey).ADVANCED_PERMISSIONS]: "pfPagePermissionsUsed",
            [(0, $oCj79.PremiumFeatureKey).ANALYTICS]: "pfAnalyticsUsed",
            [(0, $oCj79.PremiumFeatureKey).AUTOMATION]: "pfAutomationUsed",
            [(0, $oCj79.PremiumFeatureKey).TEAM_CALENDAR]: "pfTeamCalenderUsed"
        };
        $[0] = t1;
    } else t1 = $[0];
    const analyticsMapper = t1;
    let pto2Attributes;
    if ($[1] !== featureUsageMapper) {
        pto2Attributes = {};
        Object.keys(featureUsageMapper).map((fName)=>featureUsageMapper[fName] === false && (pto2Attributes[analyticsMapper[fName]] = true));
        $[1] = featureUsageMapper;
        $[2] = pto2Attributes;
    } else pto2Attributes = $[2];
    let t2;
    if ($[3] !== featureUsageMapper || $[4] !== rawSharedFeaturesMapper || $[5] !== shouldUpdate) {
        t2 = shouldUpdate ? rawSharedFeaturesMapper.map((obj)=>({
                ...obj,
                checkIconStatus: featureUsageMapper[obj.featureKey] ? (0, $9eYxl.CheckIconStatus).UNCHECKED : (0, $9eYxl.CheckIconStatus).CHECKED
            })) : rawSharedFeaturesMapper;
        $[3] = featureUsageMapper;
        $[4] = rawSharedFeaturesMapper;
        $[5] = shouldUpdate;
        $[6] = t2;
    } else t2 = $[6];
    const updatedSharedFeaturesMapperWithCheckIconStatus = t2;
    let t3;
    if ($[7] !== pto2Attributes || $[8] !== totalFeaturesUsed || $[9] !== updatedSharedFeaturesMapperWithCheckIconStatus) {
        t3 = {
            updatedSharedFeaturesMapperWithCheckIconStatus: updatedSharedFeaturesMapperWithCheckIconStatus,
            totalFeaturesUsed: totalFeaturesUsed,
            pto2Attributes: pto2Attributes
        };
        $[7] = pto2Attributes;
        $[8] = totalFeaturesUsed;
        $[9] = updatedSharedFeaturesMapperWithCheckIconStatus;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ shouldUpdate: shouldUpdate, rawSharedFeaturesMapper: rawSharedFeaturesMapper })=>{
    const { totalFeaturesUsed: totalFeaturesUsed, featureUsageMapper: featureUsageMapper } = $a9db61638509c9e5$export$4f2bb5b3a8eacebe();
    const analyticsMapper = {
        [(0, $oCj79.PremiumFeatureKey).ADVANCED_PERMISSIONS]: 'pfPagePermissionsUsed',
        [(0, $oCj79.PremiumFeatureKey).ANALYTICS]: 'pfAnalyticsUsed',
        [(0, $oCj79.PremiumFeatureKey).AUTOMATION]: 'pfAutomationUsed',
        [(0, $oCj79.PremiumFeatureKey).TEAM_CALENDAR]: 'pfTeamCalenderUsed'
    };
    const pto2Attributes = {};
    Object.keys(featureUsageMapper).map((fName)=>featureUsageMapper[fName] === false && (pto2Attributes[analyticsMapper[fName]] = true));
    const updatedSharedFeaturesMapperWithCheckIconStatus = shouldUpdate ? rawSharedFeaturesMapper.map((obj)=>({
            ...obj,
            checkIconStatus: featureUsageMapper[obj.featureKey] ? (0, $9eYxl.CheckIconStatus).UNCHECKED : (0, $9eYxl.CheckIconStatus).CHECKED
        })) : rawSharedFeaturesMapper;
    return {
        updatedSharedFeaturesMapperWithCheckIconStatus: updatedSharedFeaturesMapperWithCheckIconStatus,
        totalFeaturesUsed: totalFeaturesUsed,
        pto2Attributes: pto2Attributes
    };
};
function $a9db61638509c9e5$var$_temp(count, value) {
    return count + (value === false ? 1 : 0);
}
module.exports["usePremiumFeatureUsage"] = $a9db61638509c9e5$export$4f2bb5b3a8eacebe;
module.exports["usePremiumFeatureUsageIcon"] = $a9db61638509c9e5$export$27c06a9fba830ff1;

});

parcelRegister("kkAiW", function(module, exports) {
const $a040bf62e91f8160$export$87e78068075871d0 = (trialDaysLeft)=>{
    return 0 < trialDaysLeft && trialDaysLeft <= 15;
};
module.exports["getIsTrialInLast15Days"] = $a040bf62e91f8160$export$87e78068075871d0;

});

parcelRegister("dc00l", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4oZIh = parcelRequire("4oZIh");

const $89916392955e2c6f$var$COMMERCE_BACKEND_CCP = 'CCP';
const $89916392955e2c6f$var$COMMERCE_BACKEND_HAMS = 'HAMS';
/**
 * Trial length for RT instance with CCP is 30 days and with HAMS is 7 days
 */ const $89916392955e2c6f$var$TRIAL_DAYS = {
    [$89916392955e2c6f$var$COMMERCE_BACKEND_CCP]: 30,
    [$89916392955e2c6f$var$COMMERCE_BACKEND_HAMS]: 7,
    DEFAULT: 14
};
const $89916392955e2c6f$export$d16e6f35dca2148e = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { isPTORTEnabled: t1, isSiteAdmin: t2 } = t0;
    const isPTORTEnabled = t1 === undefined ? false : t1;
    const isSiteAdmin = t2 === undefined ? false : t2;
    const t3 = !isPTORTEnabled;
    let t4;
    if ($[0] !== t3) {
        t4 = {
            skip: t3
        };
        $[0] = t3;
        $[1] = t4;
    } else t4 = $[1];
    const { trialDaysLeft: trialDaysLeft, isInstanceInTrial: isInstanceInTrial, trialDetailsLoading: trialDetailsLoading, trialDetailsError: trialDetailsError, billingSourceSystem: billingSourceSystem } = (0, $4oZIh.useTrialDetails)(t4);
    const [showPTORTModal, setShowPTORTModal] = (0, $42omo.useState)(false);
    const [showMidTrialModal, setShowMidTrialModal] = (0, $42omo.useState)(false);
    const [checkPTOModalVisibilityLoading, setCheckPTOModalVisibilityLoading] = (0, $42omo.useState)(true);
    let t5;
    let t6;
    if ($[2] !== billingSourceSystem || $[3] !== isInstanceInTrial || $[4] !== isSiteAdmin || $[5] !== trialDaysLeft || $[6] !== trialDetailsError || $[7] !== trialDetailsLoading) {
        t5 = ()=>{
            if (!trialDetailsLoading) {
                const trialDays = billingSourceSystem ? $89916392955e2c6f$var$TRIAL_DAYS[billingSourceSystem] : $89916392955e2c6f$var$TRIAL_DAYS.DEFAULT;
                const trialDaysUsed = trialDetailsError || !isInstanceInTrial ? 0 : trialDays - trialDaysLeft;
                if (billingSourceSystem === $89916392955e2c6f$var$COMMERCE_BACKEND_CCP) {
                    setShowPTORTModal(trialDaysUsed >= 3);
                    setShowMidTrialModal(!isSiteAdmin && trialDaysUsed >= 15);
                } else {
                    setShowPTORTModal(trialDaysUsed >= 2);
                    setShowMidTrialModal(!isSiteAdmin && trialDaysUsed >= 4);
                }
                setCheckPTOModalVisibilityLoading(false);
            }
        };
        t6 = [
            billingSourceSystem,
            isInstanceInTrial,
            isSiteAdmin,
            setShowMidTrialModal,
            setShowPTORTModal,
            trialDaysLeft,
            trialDetailsError,
            trialDetailsLoading
        ];
        $[2] = billingSourceSystem;
        $[3] = isInstanceInTrial;
        $[4] = isSiteAdmin;
        $[5] = trialDaysLeft;
        $[6] = trialDetailsError;
        $[7] = trialDetailsLoading;
        $[8] = t5;
        $[9] = t6;
    } else {
        t5 = $[8];
        t6 = $[9];
    }
    (0, $42omo.useEffect)(t5, t6);
    const t7 = trialDetailsLoading || checkPTOModalVisibilityLoading;
    let t8;
    if ($[10] !== showMidTrialModal || $[11] !== showPTORTModal || $[12] !== t7) {
        t8 = {
            showPTORTModal: showPTORTModal,
            showMidTrialModal: showMidTrialModal,
            loading: t7
        };
        $[10] = showMidTrialModal;
        $[11] = showPTORTModal;
        $[12] = t7;
        $[13] = t8;
    } else t8 = $[13];
    return t8;
} : ({ isPTORTEnabled: isPTORTEnabled = false, isSiteAdmin: isSiteAdmin = false })=>{
    const { trialDaysLeft: trialDaysLeft, isInstanceInTrial: isInstanceInTrial, trialDetailsLoading: trialDetailsLoading, trialDetailsError: trialDetailsError, billingSourceSystem: billingSourceSystem } = (0, $4oZIh.useTrialDetails)({
        skip: !isPTORTEnabled
    });
    const [showPTORTModal, setShowPTORTModal] = (0, $42omo.useState)(false);
    const [showMidTrialModal, setShowMidTrialModal] = (0, $42omo.useState)(false);
    const [checkPTOModalVisibilityLoading, setCheckPTOModalVisibilityLoading] = (0, $42omo.useState)(true);
    (0, $42omo.useEffect)(()=>{
        if (!trialDetailsLoading) {
            // if we know the billing engine, we go ahead with engine defaults else, 14 days.
            const trialDays = billingSourceSystem ? $89916392955e2c6f$var$TRIAL_DAYS[billingSourceSystem] : $89916392955e2c6f$var$TRIAL_DAYS.DEFAULT;
            //forcing not to show any modals when instance is not in trial or trialDaysUsed cannot be determined
            const trialDaysUsed = trialDetailsError || !isInstanceInTrial ? 0 : trialDays - trialDaysLeft;
            /**
       * Show initial modal on
       * day 2 and onwards for HAMS and day 3 and onwards for CCP
       * Show mid trial modal to non site admins on day 4 and onwards for HAMS and day 15 and onwards for CCP
       */ if (billingSourceSystem === $89916392955e2c6f$var$COMMERCE_BACKEND_CCP) {
                setShowPTORTModal(trialDaysUsed >= 3);
                setShowMidTrialModal(!isSiteAdmin && trialDaysUsed >= 15);
            } else {
                setShowPTORTModal(trialDaysUsed >= 2);
                setShowMidTrialModal(!isSiteAdmin && trialDaysUsed >= 4);
            }
            setCheckPTOModalVisibilityLoading(false);
        }
    }, [
        billingSourceSystem,
        isInstanceInTrial,
        isSiteAdmin,
        setShowMidTrialModal,
        setShowPTORTModal,
        trialDaysLeft,
        trialDetailsError,
        trialDetailsLoading
    ]);
    return {
        showPTORTModal: showPTORTModal,
        showMidTrialModal: showMidTrialModal,
        loading: trialDetailsLoading || checkPTOModalVisibilityLoading
    };
};
module.exports["usePTOModalVisibilityOnReverseTrial"] = $89916392955e2c6f$export$d16e6f35dca2148e;

});


//# sourceMappingURL=PremiumOnboarding.ac6d7d90.js.map
